import ApiService from './ApiService';

export default {
  /**
   * Finds a user by ID
   * @param {number} id User ID
   * @returns {Promise<any>}
   */
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
        includes: 'accounts',
      };
      ApiService.request('GET', 'billing/plans', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Creates a new user account
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  create(data) {
    return new Promise((resolve, reject) => {
      ApiService.request('POST', 'billing/plans', data).then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  /**
   * Updates a user account
   * @param {number} id User ID
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `billing/plans/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
  * Remove a color map by ID
  * @param {number} id Color Map ID
  * @returns {Promise<any>}
  */
  remove(id) {
    return new Promise((resolve, reject) => {
      ApiService.request('DELETE', `billing/plans/${id}`, {}).then((response) => {
        resolve(response.data);
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
